module.exports = __webpack_public_path__ + "static/media/home_intro_bg.be40b08e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_intro_bg.svg
// module id = 311
// module chunks = 1